function TopBarThemeToggle() {
  return null;
}

export default TopBarThemeToggle;